export default "__VITE_ASSET__DwKrbKnv__"